export default {
    lang: {
        name: 'First played during date range'
    }
}